import React, { Children, useEffect, useState } from "react";
import {
  useFieldArray,
  useFormContext,
  useFormState,
  useWatch,
} from "react-hook-form";
import { Button } from "react-bootstrap";
import "./NFormTable.css";

export interface IProps {
  children?: React.ReactNode;
  fieldArray?: string | any;
  onFieldValueChanged?: (
    fieldName: string,
    index: number,
    oldValue: any,
    newValue: any
  ) => void;
  emptyMessage?: string;
}

export const NFSalaryAccrualsTableList = ({
  children,
  fieldArray,
  onFieldValueChanged,
  emptyMessage = "No items in table...",
}: IProps) => {
  const arrayChildren = Children.toArray(children);

  const {
    register,
    control,
    watch,
    formState: { errors },
    getValues,
    setValue,
    resetField,
  } = useFormContext();
  const { dirtyFields } = useFormState();
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldArray,
  });
  const watchFieldArray = watch(fieldArray);

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  const handleAddNewRow = () => {
    append({
      lineNo: fields.length + 1,
    });
  };

  const handleRemoveRow = (index: number) => {
    remove(index);
    const newFieldArray = getValues(fieldArray);
    newFieldArray.forEach((field: any, index: number) => {
      if (field.lineNo !== index + 1) {
        field.lineNo = index + 1;
      }
    });
    setValue(fieldArray, newFieldArray);
  };

  return (
    <>
      <div className={"w-100"}>
        <Button
          variant=""
          className="btn btn-sm btn-primary mb-3"
          onClick={handleAddNewRow}
        >
          Add
        </Button>
        <div className={"scroll"}>
          <table className={"table table-sm table-hover"}>
            <thead>
              <tr>
                {arrayChildren &&
                  arrayChildren.map((field: any, index) => {
                    return (
                      <th key={index} className="fw-normal">
                        {field.props?.title}
                      </th>
                    );
                  })}
                <th className="fw-normal">Actions</th>
              </tr>
            </thead>
            <tbody>
              {controlledFields.map((field, index) => {
                return (
                  <tr key={index}>
                    {arrayChildren &&
                      arrayChildren.map((column: any, columnIndex) => {
                        if (column.props.required === true) {
                          register(
                            `${fieldArray}[${index}].${column.props.fieldName}`,
                            { required: true }
                          );
                        }
                        return (
                          <td style={{ margin: "0 auto" }} key={columnIndex}>
                            {React.cloneElement(column, {
                              fieldName: `${fieldArray}[${index}].${column.props.fieldName}`,
                              showBorder: false,
                              title: undefined,
                              index: index,
                              value: field[column.props.fieldName],
                              tableName: fieldArray,
                              tableFieldName: column.props.fieldName,
                            })}
                          </td>
                        );
                      })}
                    <td className={"text-center"} style={{ width: 50 }}>
                      <a
                        href={"#"}
                        className={"text-danger"}
                        onClick={() => handleRemoveRow(index)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {controlledFields.length === 0 && (
            <div className={"w-100 text-center h5 pt-3"}> {emptyMessage} </div>
          )}
        </div>
      </div>
    </>
  );
};
